import React from 'react';
import { Card, CardContent, Typography, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';

const MONTH_NAMES = [
  '', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

const formatCurrency = (value) => `$${Math.abs(value).toLocaleString()}`;

export default function CategoryDetailChart({ category, onClose }) {
  if (!category) return null;

  // Convert monthly map { "2025-01": { total, count } } into sorted chart data
  const chartData = Object.entries(category.monthly || {})
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([key, data]) => {
      const [, monthNum] = key.split('-');
      return {
        name: MONTH_NAMES[parseInt(monthNum, 10)] || key,
        amount: data.total,
      };
    });

  return (
    <Card>
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Box>
            <Typography variant="h6">{category.category}</Typography>
            <Typography variant="body2" color="text.secondary">
              Monthly avg: {formatCurrency(category.average_monthly)} | Total: {formatCurrency(category.total)}
            </Typography>
          </Box>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        {chartData.length === 0 ? (
          <Typography color="text.secondary" sx={{ py: 4, textAlign: 'center' }}>
            No monthly data available.
          </Typography>
        ) : (
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={chartData} margin={{ top: 5, right: 20, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
              <XAxis dataKey="name" />
              <YAxis tickFormatter={formatCurrency} />
              <Tooltip formatter={(val) => formatCurrency(val)} />
              <Bar dataKey="amount" fill="#1976d2" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
}
